import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";

export const Lightbox = ({ state, onChange }) => {
  const { photos = [], index = 0, open = false } = state;
  const touchX = useRef(null);
  const p = photos[index];
  const go = (d) => onChange({ ...state, index: (index + d + photos.length) % photos.length });
  const onTouchEnd = (e) => {
    if (touchX.current == null || photos.length < 2) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    touchX.current = null;
  };
  return (
    <Dialog open={open && !!p} onOpenChange={(o) => onChange({ ...state, open: o })}>
      <DialogContent className="max-w-4xl p-2 sm:p-3 bg-white rounded-3xl" data-testid="lightbox">
        <DialogTitle className="sr-only">Pratinjau gambar</DialogTitle>
        <DialogDescription className="sr-only">{p?.caption || "Gambar"}</DialogDescription>
        {p && (
          <div>
            <div className="relative" onTouchStart={(e) => { touchX.current = e.touches[0].clientX; }} onTouchEnd={onTouchEnd}>
              <img src={p.src || fileUrl(p.id)} alt={p.caption || "Gambar"} className="w-full max-h-[80vh] object-contain rounded-2xl bg-nanina-bg" data-testid="lightbox-image" />
              {photos.length > 1 && (
                <>
                  <button onClick={() => go(-1)} className="absolute left-2 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center rounded-full bg-white/90 text-nanina-green" aria-label="Sebelumnya" data-testid="lightbox-prev"><ChevronLeft /></button>
                  <button onClick={() => go(1)} className="absolute right-2 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center rounded-full bg-white/90 text-nanina-green" aria-label="Berikutnya" data-testid="lightbox-next"><ChevronRight /></button>
                </>
              )}
            </div>
            {p.caption && <p className="px-2 pt-2 pb-1 text-sm text-nanina-green" data-testid="lightbox-caption">{p.caption}</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
